// API Configuration
// Force same-origin in production to avoid CORS/cookie issues

const getApiUrl = () => {
  // Always use same origin - the backend is accessible via /api on the same domain
  return `${window.location.origin}/api`;
};

export const API_URL = getApiUrl();
export const BACKEND_URL = window.location.origin;

export default API_URL;
